module.exports = __webpack_public_path__ + "static/img/zt2-pic12.059fd5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/zt2-pic12.jpg
// module id = YUrf
// module chunks = 171